var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('NavBar'),_vm._v(" "),_c('div',{staticClass:"content-container"},[_c('router-view')],1),_vm._v(" "),_c('InActiveNotification')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fe21dac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/node_modules/vue-loader/lib/selector.js?type=template&index=0!/src/App.vue
// module id = null
// module chunks = 